import { useState, useEffect, useRef } from 'react';
import Bredcrum from '../../components/bredcrum';
import { Toast } from 'primereact/toast';
import { userservices } from '../../services/userServices';
import { productservices } from '../../services/productServices';
import { saleServices } from "../../services/saleServices";
import { Titlebar } from '../../components/fieldsComp';
import {Loaderoverlay} from "../../components/loaderComp";
import { useNavigate, useLocation } from 'react-router';
import { Field, Formik, Form, ErrorMessage } from 'formik';
import {useSelector} from 'react-redux';
import { shipmentServices } from "../../services/shipmentServices";
import { Submissionbtn } from "../../components/buttons";

const Editsale = () => {
  const [productlist, setProductlist] = useState([]);
  const toast = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const saleData = location.state?.sale;
  const currencyreducer = useSelector((state) => state.currencyreducer);
  const [currencies, setCurrencies] = useState([]);
  const [freightlist, setFreightlist] = useState([]);
  const [submitted,setSubmitted] = useState(true);
  const [isloaded,setLoading] = useState(true);
  const [customerData, setCustomerData] = useState([]);
  const [selectCustomer, setSelectCustomer] = useState('');

  const defaultFormData = {
    order_id: '',
    sales_channel: '',
    product_id: '',
    units_sold: '',
    sku_code: '',
    sales_price: '',
    freight_charges: '',
    royalties: '',
    stock_reduction: '',
    order_status: '',
    customer_name: '',
    customer_email: '',
    customer_mobile: '',
    freight_provider: '',
  };

  const [formData, setFormData] = useState(defaultFormData);
  const customerOption = [];

  for(let i=0; i<customerData.length; i++){
    customerOption.push(<option value={customerData[i].customer_name}>{customerData[i].customer_name}</option>)
  }

  useEffect(() => {
    getproduct();
    getcurrency();
    getfreightlist();
    if (saleData) {
        console.log("Sale data received for editing:", saleData);
      setFormData({ ...defaultFormData, ...saleData });
    }
  }, [saleData]);

  const getproduct = () => {
    setLoading(false);
    productservices.getstockproduct().then((response) => {
      if (response.status === 200) {
        setProductlist(response.data.data);
        setCustomerData(response.data.customer_data);
        setLoading(true);
      } else {
        setProductlist([]);
        setLoading(true);
      }
    }).catch(() => {
      setProductlist([]);
      setLoading(true);
    });
  };

  const handleSubmit = (values) => {
    setSubmitted(false);
    saleServices.editsale(values).then((response) => {
      if (response.status === 200) {
        toast.current.show({ severity: 'success', summary: 'Success', detail: 'Sale updated successfully' });
        navigate(-1);
        setSubmitted(true);
      } else {
        toast.current.show({ severity: 'error', summary: 'Error', detail: `${response.data.data}` });
        setSubmitted(true);
      }
    }).catch((error) => {
      setSubmitted(true);
      if (error.response && error.response.data && error.response.data.errors) {
            const errors = error.response.data.errors;
            // Show each error using toast
            Object.keys(errors).forEach((field) => {
                errors[field].forEach((msg) => {
                    toast.current.show({
                        severity: 'error',
                        summary: field,
                        detail: msg,
                        life: 5000
                    });
                });
            });
        } else {
            toast.current.show({ 
                severity: 'error', 
                summary: 'Sale', 
                detail: 'An unexpected error occurred' 
            });
        }
    });
  };

  const validate = (values) => {
    const errors = {};
    const selectedProduct = productlist.find((p) => String(p.id) == values.product_id);

    if (!values.order_id) errors.order_id = "Order ID is required";
    if (!values.sales_channel) errors.sales_channel = "Sales Channel is required";
    if (!values.product_id) errors.product_id = "Product is required";
    if (!values.sku_code) errors.sku_code = "SKU Code is required";
  
    if (!values.units_sold) {
      errors.units_sold = "Units Sold is required";
    } else if (parseInt(values.units_sold) < 1) {
      errors.units_sold = "Must be at least 1";
    } else if (
      selectedProduct &&
      parseInt(values.units_sold) > selectedProduct.available_stock
    ) {
      // errors.units_sold = `Units Sold (${values.units_sold}) cannot exceed Available Stock (${selectedProduct.available_stock})`;
    }

    if (!values.sales_price) errors.sales_price = "Sales Price is required";
    if (!values.order_status) errors.order_status = "Order Status is required";
    if (!values.customer_name) errors.customer_name = "Customer Name is required";
    if (!values.customer_email) errors.customer_email = "Customer Email is required";
    if (!values.customer_mobile) errors.customer_mobile = "Customer Mobile No. is required";

    return errors;
  };
const getcurrency = () => {
    currencyreducer.then((response)=>{
       setCurrencies(response);
      }).catch((error)=>{
    });
   } 
const displayCurrency = () => {
    let items = [];
    currencies.forEach((value,index)=>{
       items.push(<option key={index} value={value.code}>{value.code}</option>);
    })  
    return items;
  }
  const getfreightlist = () =>{
        shipmentServices.getfreightlist().then((response)=>{
          console.warn(response);
            if(response.status ==200){
                setFreightlist(response.data.data);  
            }else{
                setFreightlist([]); 
            }
             
          }).catch((error)=>{
                setFreightlist([]); 
          });
      }
  return (
    <>
      <Toast ref={toast} />
      <Bredcrum title={'Sales / Edit Sale'} divider={false} />
      {/* <Titlebar text={'Edit Sale'} /> */}
      <Loaderoverlay isloaded={isloaded}/>
      <div className="col-md-12 mt-3">
        <div className="card ps-3 pe-3">
          <div className="card-body card-body-style">
            <Formik
              initialValues={formData}
              enableReinitialize
              validate={validate}
              onSubmit={handleSubmit}
            >
              {({ values, setFieldValue, resetForm }) => (
                <Form>
                  <div className="row">
                    <div className="col-md-6 form-group">
                      <label>Order ID</label>
                      <Field
                        type="text"
                        name="order_id"
                        className="form-control"
                        placeholder="Enter Order ID"
                        readOnly
                      />
                      <ErrorMessage name="order_id" component="div" className="text-danger" />
                    </div>

                    <div className="col-md-6 form-group">
                      <label>Sales Channel</label>
                      <Field
                        as="select"
                        name="sales_channel"
                        className="form-control"
                        readOnly
                        required
                      >
                        <option value="">Select Sales Channel</option>
                        <option value="Shopify">Shopify</option>
                        <option value="Superdrug">Superdrug</option>
                        <option value="Amazon">Amazon</option>
                        <option value="eBay">eBay</option>
                      </Field>
                      <ErrorMessage name="sales_channel" component="div" className="text-danger" />
                    </div>

                    <div className="col-md-6 form-group">
                        <label>Sales Date</label>
                        <Field
                        type="datetime-local"
                        name="sales_date"
                        className="form-control"
                        required
                      />
                        
                      <ErrorMessage name="sales_channel" component="div" className="text-danger" />
                      </div>

                    <div className="col-md-6 form-group">
                      <label>Product Sold</label>
                      <Field
                        as="select"
                        name="product_id"
                        className="form-control"
                        // readOnly
                        disabled
                        required
                        onChange={(e) => {
                          const { name, value } = e.target;
                          setFieldValue(name, value);
                          const selectedProduct = productlist.find(p => String(p.id) === value);
                          if (selectedProduct) {
                            setFieldValue("sku_code", selectedProduct.sku_code);
                          } else {
                            setFieldValue("sku_code", "");
                          }
                        }}
                      >
                        <option value="">Select Product</option>
                        {productlist.map((product) => (
                          <option key={product.id} value={product.id}>
                            {product.product_name}
                          </option>
                        ))}
                      </Field>
                      <ErrorMessage name="product_id" component="div" className="text-danger" />
                    </div>

                    <div className="col-md-6 form-group">
                      <label>Units Sold</label>
                      <Field
                        type="number"
                        name="units_sold"
                        className="form-control"
                        placeholder="Enter Units Sold"
                        required
                      />
                      {/* <ErrorMessage name="units_sold" component="div" className="text-danger" /> */}
                    </div>

                    <div className="col-md-6 form-group">
                      <label>Product SKU Code</label>
                      <Field
                        type="text"
                        name="sku_code"
                        className="form-control"
                        readOnly
                      />
                      <ErrorMessage name="sku_code" component="div" className="text-danger" />
                    </div>

                    <div className="col-md-6 form-group">
                      <label>Selling Price (Per Unit)</label>
                      <div className="flex-box">
                        <Field as="select" name="currency" className="form-control" style={{width:'100px'}}
                    disabled={values.order_status != 'Open'}
                >
                        {displayCurrency()}
                </Field>
                      <Field
                        type="number"
                        name="sales_price"
                        className="form-control"
                        readOnly
                        required
                      />
                      </div>
                      <ErrorMessage name="sales_price" component="div" className="text-danger" />
                    </div>

                    <div className="col-md-6 form-group">
                      <label>Freight Charges (for the whole order)</label>
                      <div className="flex-box">
                        <Field as="select" name="freight_currency" className="form-control" style={{width:'100px'}}
                            disabled={values.order_status != 'Open'}
                    >
                            {displayCurrency()}
                    </Field> 
                      <Field
                        type="text"
                        name="freight_charges"
                        className="form-control"
                        required
                      />
                      </div>
                      <ErrorMessage name="freight_charges" component="div" className="text-danger" />
                    </div>
                     {/* Freight Provider */}
                    <div className="col-md-6 form-group">
                        <label>Freight Provider</label>
                       <Field
                        as="select"
                        name="freight_provider"
                        className="form-select"
                        >
                        <option value="">Select Type</option>
                        {freightlist.map((row, index) => (
                            <option key={index} value={row.id}>
                            {row.name}
                            </option>
                        ))}
                        </Field>
                        

                        <ErrorMessage name="freight_provider" component="div" className="text-danger" />
                    </div>

                    <div className="col-md-6 form-group">
                      <label>Royalties</label>
                      <Field
                        type="number"
                        name="royalties"
                        className="form-control"
                        required
                      />
                      <ErrorMessage name="royalties" component="div" className="text-danger" />
                    </div>

                    <div className="col-md-6 form-group">
                      <label>Stock Reduction</label>
                      <Field
                        type="number"
                        name="stock_reduction"
                        className="form-control"
                        required
                      />
                      <ErrorMessage name="stock_reduction" component="div" className="text-danger" />
                    </div>

                    <div className="col-md-6 form-group">
                      <label>Order Status</label>
                      <Field
                        as="select"
                        name="order_status"
                        className="form-control"
                        required
                      >
                       <option value="">Select Order Status</option>
                                    <option value="Open">Open</option>
                                    <option value="Confirmed">Confirmed</option>
                                    <option value="Packed">Packed</option>
                                    <option value="Shipped">Shipped</option>
                                    <option value="Delivered">Delivered</option>
                                    <option value="Closed">Closed</option>
                                    <option value="Cancelled">Cancelled</option>
                                    <option value="Returned">Returned</option>
                      </Field>
                      <ErrorMessage name="order_status" component="div" className="text-danger" />
                    </div>
                     <p className="text-info pt-2">Customer Info :</p>
                    <div className="col-md-6 form-group">
                      <label>Customer Name</label>
                      {/* <Field
                        type="text"
                        name="customer_name"
                        className="form-control"
                        required
                      /> */}
                      <Field 
                       as="select"
                      name="customer_name"
                      className="form-control"
                      required
                      >
                          {customerOption}
                      </Field>
                      <ErrorMessage name="customer_name" component="div" className="text-danger" />
                    </div>
                    <div className="col-md-6 form-group">
                      <label>Customer Email</label>
                      <Field
                        type="email"
                        name="customer_email"
                        className="form-control"
                        required
                      />
                      <ErrorMessage name="customer_email" component="div" className="text-danger" />
                    </div>
                    <div className="col-md-6 form-group">
                      <label>Customer Mobile</label>
                      <Field
                        type="text"
                        name="customer_mobile"
                        className="form-control"
                        required
                      />
                      <ErrorMessage name="customer_mobile" component="div" className="text-danger" />
                    </div>
                  </div>

                  <div className="row mt-4">
                    <div className="col-md-6">
                      <Submissionbtn issaved={submitted} label1='Save' label2='Saving'/>
                      {/* <button
                        type="submit"
                        className="btn color-white me-2 w-100 rounded custom-btn-br-color custom-btn-color"
                      >
                        Save
                      </button> */}
                    </div>

                    {/* <div className="col-md-6">
                      <button
                        type="button"
                        className="btn color-white w-100 rounded custom-btn-color-secondary"
                        onClick={() => resetForm()}
                      >
                        Clear
                      </button>
                    </div> */}
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </>
  );
};

export default Editsale;
